import { ThemeProvider } from '@mui/material/styles';

import { createTheme } from '@savvy/deprecated-shared/theme';

import type { XMuiThemeProviderProps } from './types';

// Hoisted rather than built per render: the theme never varies. Light-only is
// deliberate — every surface that mounts this is a client-facing route, and
// apps/web already pins those to light mode via NextThemesProvider's forcedTheme.
const theme = createTheme({ direction: 'ltr', responsiveFontSizes: true });

export function XMuiThemeProvider({ children }: XMuiThemeProviderProps) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
